import { groq } from 'next-sanity';

import { basePostFields, categoryFields, postFields, postNextPrevFields, authorFields } from './query-fields';

export const highlightedPostsQuery = groq`*[_type == "highlightedPosts"][0].posts[]->{
  ${basePostFields}
}`;

export const allCategoriesQuery = groq`*[_type == "category"] | order(name){
  ${categoryFields}
}`;

export const firstCategoryQuery = groq`*[_type == "category"] | order(name){
  ${categoryFields}
}[0]`;

export const recentPostsQuery = groq`*[_type == "post"] | order(_createdAt desc){
  ${basePostFields}
}[0...5]`;

export const paginatedPostsQuery = groq`{
  "posts": *[_type == "post"] | order(_createdAt desc){
  	${basePostFields},
    category->{
      ${categoryFields}
    }
	}
} {
  "data": posts[(($page - 1) * $perPage)...($page * $perPage)],
	"pagination": {
    "totalItems": count(posts),
    "itemsPerPage": $perPage,
    "currentPage": $page,
	}
}`;

export const paginatedPostsByCategoryIdQuery = groq`{
  "posts": *[_type == "post" && references($categoryId)] | order(_createdAt desc){
  	${basePostFields},
    category->{
      ${categoryFields}
    }
	}
} {
  "data": posts[(($page - 1) * $perPage)...($page * $perPage)],
	"pagination": {
    "totalItems": count(posts),
    "itemsPerPage": $perPage,
    "currentPage": $page,
	}
}`;

export const paginatedPostsByAuthorIdQuery = groq`{
  "posts": *[_type == "post" && references($authorId)] | order(_createdAt desc){
    ${basePostFields},
    category->{
      ${categoryFields}
    }
	}
} {
  "data": posts[(($page - 1) * $perPage)...($page * $perPage)],
	"pagination": {
    "totalItems": count(posts),
    "itemsPerPage": $perPage,
    "currentPage": $page,
	}
}`;

export const postsSlugsQuery = groq`*[_type == "post"].slug.current`;

export const authorsSlugsQuery = groq`*[_type == "author"].slug.current`;

export const categoriesSlugsQuery = groq`*[_type == "category"] | order(_createdAt desc).slug.current`;

export const postBySlugQuery = groq`*[_type == "post" && slug.current == $postSlug]{
  ${postFields},
  seoData,
  "prevPost": *[_type == "post" && _createdAt < ^._createdAt] | order(_createdAt desc)[0]{
    ${postNextPrevFields}
  },
  "nextPost": *[_type == "post" && _createdAt > ^._createdAt] | order(_createdAt)[0]{
    ${postNextPrevFields}
  }
}[0]`;

export const postBySlugAndIdQuery = groq`*[_type == "post" && slug.current == $postSlug && _id == $postId]{
  ${postFields},
  seoData,
  "prevPost": *[_type == "post" && _createdAt < ^._createdAt] | order(_createdAt desc)[0]{
    ${postNextPrevFields}
  },
  "nextPost": *[_type == "post" && _createdAt > ^._createdAt] | order(_createdAt)[0]{
    ${postNextPrevFields}
  }
}[0]`;

export const authorBySlugAndIdQuery = groq`*[_type == "author" && slug.current == $authorSlug && _id == $authorId]{
  ${authorFields}
}[0]`;

export const postByIdQuery = groq`*[_type == "post" && _id == $postId]{
  ${postFields},
  "prevPost": *[_type == "post" && _createdAt < ^._createdAt] | order(_createdAt desc)[0]{
    ${postNextPrevFields}
  },
  "nextPost": *[_type == "post" && _createdAt > ^._createdAt] | order(_createdAt)[0]{
    ${postNextPrevFields}
  }
}[0]`;

export const authorByIdQuery = groq`*[_type == "author" && _id == $authorId]{
  ${authorFields}
}[0]`;

export const categoryBySlugQuery = groq`*[_type == "category" && slug.current == $categorySlug]{
  ${categoryFields}
}[0]`;

export const authorBySlugQuery = groq`*[_type == "author" && slug.current == $authorSlug]{
  ${authorFields}
}[0]`;
